<template>
  <div class="mt-16 pr-10">
    <div class="items-baseline sticky" style="width: 200px; top: 80px">
      <div>
        <h3
          class="text-base leading-8 pl-6 mb-6 font-semibold text-gray-92 border-l-2 border-secondary-main"
        >
          {{ categoryName }}
        </h3>
      </div>
      <nav class="mb-12">
        <ul class="ml-10">
          <li class="mb-2">
            <span
              class="text-sm cursor-pointer text-gray-62"
              :class="{
                'text-gray-92 font-semibold':
                  state.scrollY >= state.tops.section1 &&
                  state.scrollY < state.tops.section2,
              }"
              v-scroll-to="{ el: '#section1' }"
            >
              基本情報
            </span>
          </li>
          <li class="mb-2">
            <span
              class="text-sm cursor-pointer text-gray-62"
              :class="{
                'text-gray-92 font-semibold':
                  state.scrollY >= state.tops.section2 &&
                  state.scrollY < state.tops.section3,
              }"
              v-scroll-to="{ el: '#section2' }"
            >
              特長とオプション
            </span>
          </li>
          <li class="mb-2">
            <span
              class="text-sm cursor-pointer text-gray-62"
              :class="{
                'text-gray-92 font-semibold':
                  state.scrollY >= state.tops.section3 &&
                  state.scrollY < state.tops.section4,
              }"
              v-scroll-to="{ el: '#section3' }"
            >
              参考価格
            </span>
          </li>
          <li class="mb-2">
            <span
              class="text-sm cursor-pointer text-gray-62"
              :class="{
                'text-gray-92 font-semibold':
                  state.scrollY >= state.tops.section4 &&
                  state.scrollY < state.tops.section5,
              }"
              v-scroll-to="{ el: '#section4' }"
            >
              実績
            </span>
          </li>
          <li class="mb-2">
            <span
              class="text-sm cursor-pointer text-gray-62"
              :class="{
                'text-gray-92 font-semibold':
                  state.scrollY >= state.tops.section5,
              }"
              v-scroll-to="{ el: '#section5' }"
            >
              商談方法
            </span>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted, onUnmounted } from 'vue';

export default {
  props: ['categoryName', 'hasPublished'],
  setup() {
    const state = reactive({
      scrollY: 0,
      tops: {},
    });
    const scroll = () => {
      const pageYOffset = window.pageYOffset - 55;
      state.tops = {
        section1:
          document.querySelector('#section1').getBoundingClientRect().top +
          pageYOffset,
        section2:
          document.querySelector('#section2').getBoundingClientRect().top +
          pageYOffset,
        section3:
          document.querySelector('#section3').getBoundingClientRect().top +
          pageYOffset,
        section4:
          document.querySelector('#section4').getBoundingClientRect().top +
          pageYOffset,
        section5:
          document.querySelector('#section5').getBoundingClientRect().top +
          pageYOffset -
          100,
      };
      state.scrollY = window.scrollY;
    };
    onMounted(() => {
      window.addEventListener('scroll', scroll);
    });
    onUnmounted(() => {
      window.removeEventListener('scroll', scroll);
    });
    return {
      state,
    };
  },
};
</script>
